import {formly, formlyRow, formlyRow2, Option, options} from '@shared/helper/formly-helpers';
import {FormlyFieldConfig} from '@ngx-formly/core';

const days: Option[] = [
    {label: 'Mon', value: 1},
    {label: 'Tue', value: 2},
    {label: 'Wed', value: 3},
    {label: 'Thu', value: 4},
    {label: 'Fri', value: 5},
    {label: 'Sat', value: 6},
    {label: 'Sun', value: 7},
];

export const getPriceRuleForm = (type: 'NEW' | 'UPDATE') => [
    formlyRow2(formly.requiredCourseSelect('courseId', 'Course', false, {disabled: type === 'UPDATE'})),
    formlyRow2(formly.requiredText('name', 'Name')),
    formlyRow2(formly.requiredDate('season.start', 'From')),
    formlyRow2(formly.requiredDate('season.end', 'End')),
    formlyRow2(formly.boolean('isActive', 'Active')),

    formly.hr(),
    formlyRow2(formly.requiredSelect('priceType', 'Price Type', options(['WEEKDAY', 'WEEKEND']))),
    formlyRow2(formly.requiredMultiSelect('days', 'Day', days)),
    formlyRow([
        formly.requiredTime('tstart', 'Time Start'),
        formly.requiredTime('tend', 'Time End'),
    ]),
    formlyRow([
        formly.requiredNumber('minperson', 'Min Person'),
        formly.requiredNumber('maxperson', 'Max Person'),
    ]),
    formly.hr(),
    formlyRow2(formly.boolean('specialPrice', 'Special Price')),
    formlyRow2(formly.boolean('party', 'Party')),
    formlyRow2(formly.boolean('freeCart', 'Free Cart')),
    formlyRow2(formly.boolean('freeCaddy', 'Free Caddy')),
    formly.hr(),

    formly.title('Green Price'),
    formlyRow([
        formly.nestedField('map', 'Map', [
            formly.nestedField('1', '1', [
                formly.requiredNumber('sale', 'Sale'),
                formly.requiredNumber('base', 'Base'),
            ]),
        ]),
        formly.requiredNumber('originalPrice', 'Original')
    ]),

    formly.hr(),
    formly.subTitle('- Thailand Elite'),
    formlyRow([
        formly.nestedField('map', 'map', [
            formly.nestedField('2', '2', [
                formly.requiredNumber('sale', 'Member'),
                formly.requiredNumber('base', 'Base(M)'),
                formly.requiredNumber('saleGuest', 'Guest'),
                formly.requiredNumber('baseGuest', 'Base(G)'),
            ]),
        ]),
        formly.empty()
    ]),

    formly.hr(),
    formly.subTitle('- Agent OTA'),
    formlyRow([
        formly.nestedField('map', 'map', [
            formly.nestedField('3', '3', [
                formly.requiredNumber('base', 'Tier 0 Base')
            ]),
        ]),
        formly.empty()
    ]),
    formlyRow([
        formly.nestedField('map', 'map', [
            formly.nestedField('4', '4', [
                formly.requiredNumber('base', 'Tier 1 Base')
            ]),
        ]),
        formly.empty()
    ]),
    formlyRow([
        formly.nestedField('map', 'map', [
            formly.nestedField('5', '5', [
                formly.requiredNumber('base', 'Tier 2 Base')
            ]),
        ]),
        formly.empty()
    ]),
    formlyRow([
        formly.nestedField('map', 'map', [
            formly.nestedField('6', '6', [
                formly.requiredNumber('base', 'Tier 3 Base')
            ]),
        ]),
        formly.empty()
    ]),

    formly.hr(),
    formly.title('Hot Deal Price'),
    formlyRow(formly.boolean('enableHotDeal', 'Enable Hot Deal Pricing', {}, {wrappers: ['no-wrap']})),
    formlyRow([
        formly.nestedField('hotDealPrices', 'hotDealPrices', [
            formly.nestedField('3', '3', [
                formlyRow([
                    formly.number('price', 'Sale(3h)', {}, disableWhenHotDealInactive()),
                    formly.number('base', 'Base(3h)', {}, disableWhenHotDealInactive()),
                ]),
            ])
        ]),
    ]),

    formlyRow([
        formly.nestedField('hotDealPrices', 'hotDealPrices', [
            formly.nestedField('6', '6', [
                formlyRow([
                    formly.number('price', 'Sale(6h)', {}, disableWhenHotDealInactive()),
                    formly.number('base', 'Base(6h)', {}, disableWhenHotDealInactive()),
                ]),
            ])
        ]),
    ]),
    formlyRow([
        formly.nestedField('hotDealPrices', 'hotDealPrices', [
            formly.nestedField('9', '9', [
                formlyRow([
                    formly.number('price', 'Sale(9h)', {}, disableWhenHotDealInactive()),
                    formly.number('base', 'Base(9h)', {}, disableWhenHotDealInactive()),
                ]),
            ])
        ]),
    ]),
    formly.hr(),

    formly.title('Cart Settings'),
    formly.boolean('cartSetting.active', 'Use custom cart setting (instead of course default)', {}, {wrappers: ['no-wrap'], className: 'text-red-400'}),
    formly.boolean('cartSetting.require', 'Require', {}, disableWhenCartSettingInactive()),
    formly.boolean('cartSetting.maxRequire', 'Require when the maximum golfer', {}, disableWhenCartSettingInactive()),
    formly.boolean('cartSetting.sale', 'Sale', {}, disableWhenCartSettingInactive()),
    formlyRow([
        formly.number('cartSetting.priceOriginal', 'Original', {}, disableWhenCartSettingInactive()),
        formly.number('cartSetting.priceSale', 'Sale', {}, disableWhenCartSettingInactive()),
        formly.number('cartSetting.priceBase', 'Base', {}, disableWhenCartSettingInactive()),
    ]),
    formly.hr(),

    formlyRow([
        formly.textArea('notice.en', 'Email remark(EN)'),
    ]),

    formlyRow([
        formly.textArea('notice.th', 'Email remark(TH)'),
    ]),

    formly.hr(),
    formlyRow([
        formly.textArea('note', 'Note')
    ])
];

function disableWhenCartSettingInactive(): FormlyFieldConfig{
  return {
    // wrappers: ['no-wrap'],
    expressionProperties: {
      'templateOptions.disabled': '!model.cartSetting?.active',
    },
  };
}

function disableWhenHotDealInactive(): FormlyFieldConfig{
  return {
    // wrappers: ['no-wrap'],
    expressionProperties: {
      'templateOptions.disabled': (model, formState) => {
        return !formState.formModel.enableHotDeal;
      },
    },
  };
}

